import * as Types from '../../../gql/base-types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';

// =============================================================================
// Auto-generated by GraphQL Codegen - DO NOT EDIT
// Change the .gql source (or the schema) and re-run: pnpm codegen
// =============================================================================

const defaultOptions = {} as const;
export type ReinstateDriverMutationVariables = Types.Exact<{
  driverId: Types.Scalars['bigint']['input'];
}>;


export type ReinstateDriverMutation = { __typename?: 'mutation_root', update_drivers?: { __typename?: 'drivers_mutation_response', affected_rows: number, returning: Array<{ __typename?: 'drivers', id: number, status: string, tax_class: string, driver_app_version?: string | null, phone_type?: string | null, user?: { __typename?: 'users', id: number, display_name: string, email?: string | null, phone?: string | null, active: boolean, avatar_url?: string | null } | null }> } | null, update_users?: { __typename?: 'users_mutation_response', affected_rows: number, returning: Array<{ __typename?: 'users', id: number, active: boolean }> } | null };


export const ReinstateDriverDocument = gql`
    mutation ReinstateDriver($driverId: bigint!) {
  update_drivers(where: {id: {_eq: $driverId}}, _set: {status: "offline"}) {
    affected_rows
    returning {
      id
      status
      tax_class
      driver_app_version
      phone_type
      user {
        id
        display_name
        email
        phone
        active
        avatar_url
      }
    }
  }
  update_users(where: {driver: {id: {_eq: $driverId}}}, _set: {active: true}) {
    affected_rows
    returning {
      id
      active
    }
  }
}
    `;
export type ReinstateDriverMutationFn = Apollo.MutationFunction<ReinstateDriverMutation, ReinstateDriverMutationVariables>;

/**
 * __useReinstateDriverMutation__
 *
 * To run a mutation, you first call `useReinstateDriverMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReinstateDriverMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [reinstateDriverMutation, { data, loading, error }] = useReinstateDriverMutation({
 *   variables: {
 *      driverId: // value for 'driverId'
 *   },
 * });
 */
export function useReinstateDriverMutation(baseOptions?: Apollo.MutationHookOptions<ReinstateDriverMutation, ReinstateDriverMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ReinstateDriverMutation, ReinstateDriverMutationVariables>(ReinstateDriverDocument, options);
      }
export type ReinstateDriverMutationHookResult = ReturnType<typeof useReinstateDriverMutation>;
export type ReinstateDriverMutationResult = Apollo.MutationResult<ReinstateDriverMutation>;
export type ReinstateDriverMutationOptions = Apollo.BaseMutationOptions<ReinstateDriverMutation, ReinstateDriverMutationVariables>;
import { resolveExecutor, type GqlExecutor, type GqlRequestOptions } from '@hopdrive/sdk-core'


/**
 * Multiple root fields (update_drivers, update_users): returns the full response object.
 * @source {@link src/features/drivers/queries/reinstateDriver.mutation.gql}
 */
export async function reinstateDriver(
  variables: ReinstateDriverMutationVariables,
  options?: { executor?: GqlExecutor } & GqlRequestOptions
): Promise<ReinstateDriverMutation> {
  const { executor, ...requestOptions } = options ?? {}
  return resolveExecutor(executor).mutate<ReinstateDriverMutation>(
    ReinstateDriverDocument,
    variables,
    requestOptions
  )
}